import request from '../request';

const execute = async ({ start, intervalType, reactivateStation }) => {
  try {
    const requestData = {
      start,
      intervalType,
      reactivateStation,
    };

    const response = await request.post(`/pause`, requestData);

    if (response.err) {
      return {
        err: true,
        data: {
          ...response.data,
        },
      };
    }

    return { err: false, data: response?.data };
  } catch (error) {
    return {
      err: true,
      data: {
        errorMessage: 'Erro interno',
        error,
      },
    };
  }
};

export default execute;
